/**
 * Returns an object with all email-related state properties reset to their initial values
 * @returns The reset email state
 */
export const getResetEmailState = (): {
    newEmailAddress: string;
    confirmEmailAddress: string;
    emailError: null;
    newEmailError: boolean;
    confirmEmailError: boolean;
    newEmailSuccess: boolean;
    confirmEmailSuccess: boolean;
    showEmailEdit: boolean;
} => {
    return {
        newEmailAddress: "",
        confirmEmailAddress: "",
        emailError: null,
        newEmailError: false,
        confirmEmailError: false,
        newEmailSuccess: false,
        confirmEmailSuccess: false,
        showEmailEdit: false,
    };
};
